export interface OrderTimingData {
  orderId: string;
  startTime: number;
}

// Store order timestamps
const orderTimings = new Map<string, OrderTimingData>();

// Start timing when order is placed
export const startOrderTiming = (orderId: string): string => {
  const startTime = performance.now();

  console.log(`[ORDER_TIMING] Market order placed ${orderId} at ${new Date().toISOString()}`);

  orderTimings.set(orderId, {
    orderId,
    startTime,
  });

  return orderId;
};

// End timing when order is filled
export const endOrderTiming = (orderId: string): number | null => {
  const orderData = orderTimings.get(orderId);

  if (orderData) {
    const endTime = performance.now();
    const duration = endTime - orderData.startTime;

    console.log(
      `[ORDER_TIMING] Market order with ID: ${orderId} received fill at ${new Date().toISOString()}`
    );
    console.log(
      `[ORDER_TIMING] Time elapsed: ${duration.toFixed(2)}ms (${(duration / 1000).toFixed(2)}s)`
    );

    // Clean up
    orderTimings.delete(orderId);

    return duration;
  } else {
    console.warn(`[ORDER_TIMING] No start time found for order ID: ${orderId}`);
    return null;
  }
};
